import { create } from 'zustand';

import { ValueLists } from '@ohpen/enso-ui';
import { FieldType, optionsGetAllOptionsForFields } from '@pmp/api';

export type GetValueListsProps = {
  fetchIfMissing?: FieldType[];
  alwaysFetch?: FieldType[];
};

type ValueListsStore = {
  valueLists: ValueLists;
  isLoadingValueLists: boolean;
  getValueLists: (params?: GetValueListsProps) => Promise<void>;
};

export const useValueListsStore = create<ValueListsStore>((set, get) => {
  return {
    valueLists: {},
    isLoadingValueLists: false,

    getValueLists: async (params?: GetValueListsProps) => {
      set({ isLoadingValueLists: true });
      const always = params?.alwaysFetch ?? [];
      const missing = (params?.fetchIfMissing ?? []).filter(name => !get().valueLists[name]);
      const listsToFetch = Array.from(new Set([...always, ...missing]));
      if (!listsToFetch.length) {
        set({ isLoadingValueLists: false });
        return;
      }
      const {
        data: { fields },
      } = await optionsGetAllOptionsForFields({ query: { fields: listsToFetch } });
      if (fields) {
        set(state => ({
          valueLists: { ...state.valueLists, ...fields },
          isLoadingValueLists: false,
        }));
      } else {
        set({ isLoadingValueLists: false });
      }
    },
  };
});
